import {useEffect} from "react";

export function useClickOutside(ref, callback, isActive) {
	useEffect(() => {
		if (!isActive) return;

		function handleClickOutside(event) {
			if (ref.current && ref.current.contains(event.target)) {
				return;
			}

			const isAntPopup = event.target.closest(
				".ant-select-dropdown, .ant-picker-dropdown, .ant-modal-content, .ant-popover",
			);

			if (!isAntPopup) {
				callback();
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, callback, isActive]);
}
